import { CellStyle, ColDef } from 'ag-grid-community';
import { StoreInventoryRow } from 'src/domain/table/store-inventory.row';
import { isFurnitureColumnType } from 'src/utils/furnitureUtils';
import { numberWithSpaces } from 'src/utils/numberWithSpaces';

export const rotatedCellWidth = 60;

export const defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    enableRowGroup: true,
};

export const columns: ColDef<StoreInventoryRow>[] = [
    {
        field: 'clusterName',
        headerName: 'Cluster',
        filter: 'agTextColumnFilter',
        width: 200,
        enableRowGroup: true,
        rowGroup: true,
        hide: true,
        pinned: 'left',
        sort: 'asc',
        sortIndex: 0,
        valueFormatter({ value, node, column }) {
            if (column.isRowGroupDisplayed(column.getColId())) {
                if (node?.group) {
                    return value;
                }
                return '';
            }
            return value;
        },
        cellStyle({ node }) {
            if (node?.group) {
                return { fontWeight: 'bold' };
            }
            return undefined;
        },
    },
    {
        field: 'storeName',
        headerName: 'Store Name',
        width: 300,
        pinned: 'left',
        sort: 'asc',
        sortIndex: 1,
        filter: 'agTextColumnFilter',
        cellStyle({ node }) {
            const styles: CellStyle = {
                justifyContent: 'flex-start',
            };

            if (node?.group) {
                styles.fontWeight = 'bold';
                styles.justifyContent = 'center';
            }

            return styles;
        },
    },
    {
        field: 'countryName',
        headerName: 'Country',
        hide: true,
        width: 150,
        filter: 'agTextColumnFilter',
        sort: 'asc',
        pinned: 'left',
        sortIndex: 2,
        cellStyle({ node }) {
            if (node?.group) {
                return { fontWeight: 'bold' };
            }
            return undefined;
        },
    },
    {
        field: 'storeSize',
        headerName: 'Store Size (m²)',
        width: 150,
        type: 'numericColumn',
        pinned: 'left',
        filter: 'agNumberColumnFilter',
        cellStyle({ node }) {
            if (node?.group) {
                return { fontWeight: 'bold' };
            }
            return undefined;
        },
        aggFunc: 'sum',
        valueFormatter({ value }) {
            if (value) {
                return numberWithSpaces(value);
            }
            // Hide zeros for better readability
            return '';
        },
    },
    {
        field: 'optionSum',
        headerName: 'Total Options',
        width: rotatedCellWidth,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        pinned: 'right',
        headerClass: 'rotate-header-cell',
        aggFunc: 'sum',
        valueGetter({ data, node }) {
            if (node?.group) {
                return node.aggData?.['optionSum'] ?? 0;
            }
            // Sum all furniture for the store
            let sum = 0;
            for (const key of Object.keys(data?.furnitureColumns || {})) {
                const cellData = data!.furnitureColumns![key];
                if (isFurnitureColumnType(cellData)) {
                    sum += cellData.optionCount;
                }
            }
            return sum;
        },
    },
];
